export default {

    inviteRegisterLogoTitle1: 'Você foi convidado',
    inviteRegisterLogoTitle2: ' — ganhe agora!',
    inviteRegisterLogoTitle3: 'Seu amigo',
    inviteRegisterLogoTitle4: ' ({address}) ',
    inviteRegisterLogoTitle5: 'já está ganhando com o Astral. Agora é a sua vez!',

    inviteRegisterPlaceholder1: 'Digite email',
    inviteRegisterPlaceholder2: 'Digite número de celular',
    inviteRegisterPlaceholder3: 'Digite senha（1-32 characters）',

    inviteRegisterSubmit1: 'CRIE UMA NOVA CONTA',
    inviteRegisterSeparateLine1: '------- Registre-se por -------',

    inviteRegisterPlatformLicence1: 'Plataforma licenciada e',
    inviteRegisterPlatformLicence2: ' 100% segura.',

    inviteRegisterPlatformBox1Title1: 'Bônus de boas-vindas',
    inviteRegisterPlatformBox1Title2: 'Ambos ganham bônus ao completar o cadastro',

    inviteRegisterPlatformBox2Title1: '0% de taxa',
    inviteRegisterPlatformBox2Title2: 'Negocie a qualquer hora e em qualquer lugar, sem taxas e com mais lucros.',

    inviteRegisterPlatformBox3Title1: 'Ajuda confiável em cripto',
    inviteRegisterPlatformBox3Title2: 'De iniciante a especialista, estamos aqui para te ajudar em cada etapa.',

    inviteRegisterPlatformBox4Title1: 'Negocie com tranquilidade',
    inviteRegisterPlatformBox4Title2: 'Plataforma regulamentada, com segurança total para seu dinheiro.',

    inviteRegisterPrivacyPolicyTitle1: 'Concordo com',
    inviteRegisterPrivacyPolicyTitle2: 'Política de Privacidade',

    inviteRegisterVCodeDrawerTitleEmail: 'Verification code has been sent to your Email',
    inviteRegisterVCodeDrawerTitlePhone: 'Verification code has been sent to your Phone',

    inviteDownloadsTitle1: 'Download do APP',
    inviteDownloadsTitle2: 'Faça o download do Astral em breve',
    inviteDownloadsTitle3: 'Após a conclusão do download, vá para Login',

    inviteDownloadsBtnLabel:'download',
    inviteDownloadsAppleLabel: 'Apple store',
    inviteDownloadsGooglePlayLabel: 'Google play',
    inviteDownloadsAndroidLabel: 'Android',

    depositSuccess: 'Pay Success !',

};
